import { render, staticRenderFns } from "./ComplaintLayout.vue?vue&type=template&id=66115bcf&"
import script from "./ComplaintLayout.vue?vue&type=script&lang=js&"
export * from "./ComplaintLayout.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintLayout.vue?vue&type=style&index=0&id=66115bcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VBtn,VIcon,VMain})
